module.exports = __webpack_public_path__ + "static/media/usb-mini-gold.1c7803d5.svg";